/**
 * Imports the necessary modules from the React library and other external libraries.
 * @module React
 * @module ReactDOM
 * @module BrowserRouter
 * @module Provider
 */
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import store from "./store";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";

/**
 * Imports the necessary modules and files for the application.
 * - reportWebVitals: a module for reporting web performance metrics.
 * - store: the Redux store for managing application state.
 * - App: the main component of the application.
 * - index.css: the CSS file for styling the application.
 * - i18n: the internationalization module for supporting multiple languages.
 */
import reportWebVitals from "./reportWebVitals";
import App from "./app";
import "./i18n";
//import App from "./app";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  sendDefaultPii: true
});

// Suppress COOP (Cross-Origin-Opener-Policy) warnings from MSAL popup windows
// These warnings are harmless and don't affect functionality
const originalError = console.error;
const originalWarn = console.warn;

console.error = (...args) => {
  const message = args.join(' ');
  if (message && message.includes('Cross-Origin-Opener-Policy')) {
    return;
  }
  originalError.apply(console, args);
};

console.warn = (...args) => {
  const message = args.join(' ');
  if (message && (message.includes('Cross-Origin-Opener-Policy') || 
      message.includes('window.closed'))) {
    return;
  }
  originalWarn.apply(console, args);
};


/**
 * Creates a root element for rendering React components.
 * @param {HTMLElement} element - The root element to render the components into.
 * @returns A root object that can be used to render React components.
 */
const root = ReactDOM.createRoot(document.getElementById("root"));

/**
 * Renders the root component of the application with the provided Redux store.
 * @param {Object} store - The Redux store object.
 * @returns None
 */
root.render(
  <Provider store={store}>
    <React.Fragment>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.Fragment>
  </Provider>
);
reportWebVitals();
